import React from 'react';
import DictionaryReportsRow from '../containers/DictionaryReportsTableRow';

const DictionaryReportsTableRows = ({
  category,
  code,
  reports,
  columns,
  reportType,
}) => (
  reports.map((report, index) => (
    <DictionaryReportsRow
      key={`dataset_data_management_dictionary_reports_table_row_${report.id}`}
      category={category}
      code={code}
      reportId={report.id}
      reportType={reportType}
      columns={columns}
      upward={index > 4}
    />
  ))
);

export default DictionaryReportsTableRows;
